module.exports = __webpack_public_path__ + "img/28.0d5762d3.png";